import { Select } from 'antd';
import React from 'react';

const RemoveTagDrawerContent = ({
  removeTagOptions = [],
  selectedTagIds,
  onSelectedTagIdsChange,
}) => (
  <>
    <div className="font-size-14 mb-8">Select tags to remove</div>
    <div className="bulk-remove-tag-row">
      <div className="bulk-remove-tag-select-wrap">
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Select tags"
          value={selectedTagIds}
          onChange={onSelectedTagIdsChange}
          options={removeTagOptions}
        />
      </div>
    </div>
  </>
);

export default RemoveTagDrawerContent;
